import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  OnChanges,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { OpenInvoiceAmountsDto } from "../../../../core/models/client/details/openInvoiceAmountsDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { TableModule } from "primeng/table";
import { DecimalPipe } from "@angular/common";
import { ClientDetailsService } from "../../../../core/services/client-details.service";

@Component({
  selector: "jni-client-invoice-amounts",
  templateUrl: "./client-invoice-amounts.component.html",
  imports: [TableModule, DecimalPipe],
  styleUrls: ["./client-invoice-amounts.component.scss"],
})
export class ClientInvoiceAmountsComponent
  implements OnInit, OnDestroy, OnChanges
{
  amountList: OpenInvoiceAmountsDto[] = [];
  customerAccount = "";
  type = 0;
  heading = "";

  @Input() openInvoiceCustomerAccount!: string;
  @Input() openInvoicetype!: number;
  @Output() closeModalOnRedirectionEvent = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();

  constructor(
    private _clientDetailsService: ClientDetailsService,
    private _loaderService: LoaderService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.customerAccount = params["customerAccount"];
      this.type = params["type"];
      this.heading = `Open Invoice - ${this.type} Days`;
    });
  }

  ngOnInit(): void {
    this.openInvoiceAmounts();
  }

  ngOnChanges() {
    if (this.openInvoiceCustomerAccount) {
      this.customerAccount = this.openInvoiceCustomerAccount;
      this.type = this.openInvoicetype;
      this.heading = `Open Invoice - ${this.type} Days`;
    }
  }

  openInvoiceAmounts() {
    if (this.customerAccount && this.type) {
      this._loaderService.setLoaderState(true);
      this._clientDetailsService
        .openInvoiceAmounts(this.customerAccount, this.type)
        .subscribe({
          next: res => {
            this.amountList = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  redirectToSummary(saleOrderId: string) {
    this._router.navigate(["orders/order-summary/" + saleOrderId]);
    this.closeModalOnRedirectionEvent.emit(saleOrderId);
  }

  exportReport() {
    this.exportExcelForFilterData(this.amountList);
  }

  exportExcelForFilterData(filterclientlist: OpenInvoiceAmountsDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["CB Days"]: datum.cBDays,
        ["Invoice"]: datum.invoice,
        ["Client"]: datum.client,
        ["Job Name"]: datum.jobName,
        ["Total Amt"]: datum.totalAmount,
        ["Open Amt"]: datum.openAmount,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ChargebackAgingReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }
}
